import {AppFunction, Role} from "../misc/types";
import View from "../framework/view";
import PlayerView from "../views/player";
import {User} from "../bo/user";

export class PlayerFunction extends AppFunction {

    readonly v : View;

    private id : number;

    constructor(id: number, user: User | undefined, role: Role, autoplay: boolean) {
        super();
        this.id = id;
        this.v = new PlayerView(id, user, role, autoplay);
    }

    view() {
        return this.v;
    }

    url() {
        return `/player/${encodeURIComponent(this.id)}`;
    }

}
